export default __webpack_public_path__ + "static/media/mainBcg.80efe70f.jpeg";